import PermissionGuard from 'components/Global/PermissionGuard'; 
import BranchCodeComponent from 'components/Settings/Masters/BranchCode';

export const BranchCode = () => {
	return (
		<PermissionGuard permission="Allow_Branch_Code">
			<BranchCodeComponent />
		</PermissionGuard>
	);
};
